import React, { CSSProperties } from 'react';
import {
  LeftArrowInCircleFilled, LeftArrowInCircleLarge, RightArrowInCircleFilled, RightArrowInCircleLarge,
} from './components/Arrows';
import { Button, ButtonModes } from './components/Button';
import { CommonComponent, CommonComponentContent } from './components/CommonComponent';
import { Container } from './components/Container';
import { DangerousHTML } from './components/DangerousHTML';
import { VideoWithButton } from './components/VideoWithButton';

export interface PillarNavigation {
  title: string,
  subtitle: string,
  color: string,
  secondaryColor: string,
  darkColor: string,
  path: string
  url: string;
}

export interface PillarContentProps {
  title: string,
  subtitle: string,
  color: string,
  secondaryColor: string,
  movie: string,
  photo: string,
  next: PillarNavigation,
  previous: PillarNavigation,
  content: Array<CommonComponentContent>
}

export interface PillarNavigationButtonProps {
  title: string,
  color: string,
  arrowDirection: 'LEFT' | 'RIGHT',
  url: string,
}

const PillarNavigationButton: React.FC<PillarNavigationButtonProps> = (props: PillarNavigationButtonProps) => (
  <Button
    mode={ButtonModes.secondary}
    url={props.url}
    color={props.color}
  >
    {props.arrowDirection == 'LEFT'
      ? (
        <div className="pillar__navigation_button_content">
          <LeftArrowInCircleFilled color={props.color} />
          <span className="pillar__navigation_button_content_text">{props.title}</span>
        </div>
      )
      : (
        <div className="pillar__navigation_button_content">
          <span className="pillar__navigation_button_content_text">{props.title}</span>
          <RightArrowInCircleFilled color={props.color} />
        </div>
      )}
  </Button>
);

export const PillarContent: React.FC<PillarContentProps> = (props) => (
  <main className="pillar">
    <div className="pillar__navigation">
      <div className="pillar__navigation_prev">
        <PillarNavigationButton
          title={props.previous.title}
          url={props.previous.url}
          color={props.previous.color}
          arrowDirection="LEFT"
        />
      </div>
      <div className="pillar__navigation_next">
        <PillarNavigationButton
          title={props.next.title}
          url={props.next.url}
          color={props.next.color}
          arrowDirection="RIGHT"
        />
      </div>
    </div>
    <div className="pillar__top_unit">
      <h1 className="pillar__title" style={{ color: props.color }}>{props.title}</h1>
      <h6 className="pillar__subtitle" style={{ color: props.color }}>{props.subtitle}</h6>
    </div>
    <div className="pillar__video">
      {props.movie && <VideoWithButton movie={props.movie} />}
      {props.photo && <img src={props.photo} alt="" style={{ width: '100%' }} />}
    </div>
    {
      props.content.map((p: CommonComponentContent, index: number) => (
        <Container key={index}>
          <CommonComponent
            {...p}
            color={props.color}
            secondaryColor={props.secondaryColor}
          />
        </Container>
      ))
    }
    <div className="pillars">
      <a href={props.previous.url}>
        <div
          className="pillars__item pillars__item--clickable pillars__item--simplified"
          style={{
            '--color-bg': props.previous.secondaryColor,
            '--color-txt': props.previous.darkColor,
          } as CSSProperties}
        >
          <Container>
            <LeftArrowInCircleLarge color={props.previous.darkColor} />
            <div className="pillars__item__body">
              <DangerousHTML element="h2" html={props.previous.title} />
              <DangerousHTML element="div" html={props.previous.subtitle} />
            </div>
          </Container>
        </div>
      </a>
      <a href={props.next.url}>
        <div
          className="pillars__item pillars__item--right-align pillars__item--clickable pillars__item--simplified"
          style={{
            '--color-bg': props.next.secondaryColor,
            '--color-txt': props.next.darkColor,
          } as CSSProperties}
        >
          <Container>
            <div className="pillars__item__body">
              <DangerousHTML element="h2" html={props.next.title} />
              <DangerousHTML element="div" html={props.next.subtitle} />
            </div>
            <RightArrowInCircleLarge color={props.next.darkColor} />
          </Container>
        </div>
      </a>
    </div>
  </main>
);
